module.exports = __webpack_public_path__ + "static/media/fvs_valve1_91.bcb443ce.jpg";